import { render, staticRenderFns } from "./screen-menu-day.vue?vue&type=template&id=2cb47df8"
import script from "./screen-menu-day.vue?vue&type=script&lang=ts"
export * from "./screen-menu-day.vue?vue&type=script&lang=ts"
import style0 from "./screen-menu-day.vue?vue&type=style&index=0&id=2cb47df8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports